import { useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { useUpdaterChainId } from '~/hooks'
import { TokenlonSDK, ALL_SUPPORTED_CHAINS } from '@tokenlon/v6-sdk'
import { TokenlonEnv, ENV } from '~/constants/env'
import {
  PublicClient,
  createPublicClient,
  createWalletClient,
  http,
  custom,
} from 'viem'
import { getChainById } from '~/utils/chain'
import { useTokenlonV6NetworkConfig } from '~/state/dex/hooks'

export const useV6SDK = () => {
  const { provider } = useWeb3React()
  const expectChainId = useUpdaterChainId()
  const config = useTokenlonV6NetworkConfig()
  const rpcUrl = getChainById(expectChainId).rpcUrl

  const env = ENV.production
    ? TokenlonEnv.production
    : ENV.staging
    ? TokenlonEnv.staging
    : TokenlonEnv.development

  const addressBook = config.addressBook
  const client = createPublicClient({
    chain: ALL_SUPPORTED_CHAINS.find((c) => c.id === expectChainId),
    transport: http(rpcUrl, {
      batch: true,
    }),
  })

  const isProviderExist = !!provider?.provider
  const walletClient = useMemo(() => {
    if (!isProviderExist) {
      return undefined
    }
    return createWalletClient({
      chain: ALL_SUPPORTED_CHAINS.find((c) => c.id === expectChainId),
      transport: custom(provider?.provider as any),
    })
  }, [isProviderExist])

  const sdk = new TokenlonSDK({
    env,
    chain: expectChainId,
    rpcUrl,
    addressBook,
    client: client as PublicClient,
    walletClient,
  })

  return sdk
}
